import {useFieldContext} from '../../utils/formContext';

import {Checkbox} from './Checkbox';

type Props = Omit<React.ComponentProps<typeof Checkbox>, 'name'>;
export function FormCheckbox(props: Props): React.JSX.Element {
  const field = useFieldContext<boolean>();

  return (
    // @ts-expect-error some issue with the union
    <Checkbox
      {...props}
      name={field.name}
      value={field.name}
      onCheckedChange={(e) => field.handleChange(e === true)}
      onBlur={field.handleBlur}
      checked={field.state.value}
      // error={field.state.meta.errors.map((e) => e.message).join(', ')}
    />
  );
}
